import uuidv4 from 'uuid/v4';
import config from '../app/config';
import qs from 'qs-stringify';
import axios from 'axios';

const LocalStorage = function (storage) {
    if (!(this instanceof LocalStorage)) {
        return new LocalStorage(storage);
    }

    if (!storage) {
        console.warn("Storage parameter not set. Using 'sessionStorage' as default.");
        storage = sessionStorage;
    }

    storage.setItem('agyle', 'test');
    storage.removeItem('agyle');

    var cs = this;

    function clearExpired() {
        var time = new Date().getTime();
        for (var i = 0; i < storage.length; i++) {
            var key = storage.key(i);
            if (key && key.indexOf('agyle-') == 0) {
                var value = storage.getItem(key);
                if (value) {
                    try {
                        var expires = JSON.parse(value).expires;
                        if (!expires || (expires > -1 && expires < time)) {
                            storage.removeItem(key);
                        }
                    } catch (err) {
                        storage.removeItem(key);
                    }
                }
            }
        }
    }

    cs.get = function (state) {
        if (!state) {
            return;
        }
        clearExpired();

        var key = 'agyle-' + state;
        var value = storage.getItem(key);
        if (value) {
            // storage.removeItem(key);
            value = JSON.parse(value);
        }

        return value;
    };

    cs.add = function (state) {
        clearExpired();

        var key = 'agyle-' + state.state;
        state.expires = state.expires || new Date().getTime() + 60 * 60 * 1000;
        storage.setItem(key, JSON.stringify(state));
    };

    cs.remove = function (state) {
        var key = 'agyle-' + state;
        var value = storage.getItem(key);
        if (value) {
            storage.removeItem(key);
            value = JSON.parse(value);
        }

        return value;
    };

    cs.getDeviceId = function () {
        let deviceId = this.get('deviceId');
        if (!deviceId) {
            deviceId = {
                state: 'deviceId',
                expires: -1,
                deviceId: '' + uuidv4(),
            };
            this.add(deviceId);
        }

        return deviceId;
    };
};

class Auth {
    authorized = false;
    token = null;
    tokenParsed = null;
    refreshToken = null;
    refreshTokenParsed = null;
    idToken = null;
    idTokenParsed = null;
    timeSkew = null;

    error = null;
    errorDescription = null;

    authAxios;
    storage;
    tokenTimeoutHandle;

    refreshTokenCancelled = false;

    constructor() {
        this.authAxios = axios.create();
        this.storage = new LocalStorage(sessionStorage);
    }

    async authKeycloak(userName, password) {
        const that = this;
        return new Promise(async function (resolve, reject) {
            const url = config.auth.url + '/realms/' + config.auth.realm + '/protocol/openid-connect/token';

            const data = qs({
                client_id: config.auth.clientId,
                client_secret: config.auth.clientSecret,
                grant_type: 'password',
                username: userName,
                password: password,
            });
            const cfg = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            };

            let reqTime = new Date().getTime();

            that.authAxios
                .post(url, data, cfg)
                .then((authKeycloakResponse) => {
                    if (authKeycloakResponse.status === 200) {
                        const res = authKeycloakResponse.data;
                        if (res.access_token) {
                            reqTime = (reqTime + new Date().getTime()) / 2;

                            that.setToken(res.access_token, res.refresh_token, res.id_token, reqTime);

                            that.storage.add({
                                state: 'token',
                                expires: that.tokenParsed.exp ? that.tokenParsed.exp * 1000 : new Date().getTime() + 60 * 60 * 1000,
                                token: res.access_token,
                                refreshToken: res.refresh_token,
                            });
                            that.error = null;
                            that.errorDescription = null;

                            // TODO: redirect to main page
                            window.location.reload();
                        } else {
                            // TODO: set not authorized
                            that.storage.remove('token');
                            that.setToken();
                            that.error = 'ERR';
                            that.errorDescription = 'Unknown error';
                            reject(false);
                        }
                    } else {
                        // TODO: set not authorized
                        that.storage.remove('token');
                        that.setToken();
                        reject(false);
                    }
                })
                .catch((error) => {
                    console.error('authKeycloak error', error.response);
                    if (error.response) {
                        that.error = error.response.data.error;
                        that.errorDescription = error.response.data.error_description;
                    } else {
                        that.error = 'ERR';
                        that.errorDescription = 'Unknown error';
                    }

                    // TODO: set not authorized
                    that.storage.remove('token');
                    that.setToken();
                    reject(false);
                });
        });
    }

    async refreshKeycloakToken(minValidity) {
        const that = this;

        minValidity = minValidity || 5;

        let refreshToken = false;
        if (minValidity == -1) {
            refreshToken = true;
            console.info('[AUTH] Refreshing token: forced refresh');
        } else if (!this.tokenParsed || this.isTokenExpired(minValidity)) {
            refreshToken = true;
            console.info('[AUTH] Refreshing token: token expired');
        }

        if (!refreshToken) {
            return Promise.resolve(false);
        } else {
            return new Promise(async function (resolve, reject) {
                const url = config.auth.url + '/realms/' + config.auth.realm + '/protocol/openid-connect/token';

                const data = qs({
                    client_id: config.auth.clientId,
                    client_secret: config.auth.clientSecret,
                    grant_type: 'refresh_token',
                    refresh_token: that.refreshToken,
                });
                const cfg = {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                };

                let reqTime = new Date().getTime();

                that.authAxios
                    .post(url, data, cfg)
                    .then((refreshKeycloakResponse) => {
                        if (refreshKeycloakResponse.status === 200) {
                            const res = refreshKeycloakResponse.data;
                            if (res.access_token) {
                                reqTime = (reqTime + new Date().getTime()) / 2;

                                that.setToken(res.access_token, res.refresh_token, res.id_token, reqTime);

                                that.storage.add({
                                    state: 'token',
                                    expires: that.tokenParsed.exp ? that.tokenParsed.exp * 1000 : new Date().getTime() + 60 * 60 * 1000,
                                    token: res.access_token,
                                    refreshToken: res.refresh_token,
                                    skewTime: reqTime,
                                });

                                resolve(true);
                            } else {
                                // TODO: set failed refresh token
                                reject(false);
                            }
                        } else {
                            // TODO: set failed refresh token
                            reject(false);
                        }
                    })
                    .catch((error) => {
                        console.assert('refreshKeycloak error', error);
                        // TODO: set failed refresh token
                        reject(false);
                    });
            });
        }
    }

    async logoutKeycloak() {
        const that = this;
        return new Promise(async function (resolve, reject) {
            const url = config.auth.url + '/realms/' + config.auth.realm + '/protocol/openid-connect/logout';

            const data = qs({
                client_id: config.auth.clientId,
                client_secret: config.auth.clientSecret,
                refresh_token: that.refreshToken,
            });
            const cfg = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    // 'Authorization': 'bearer ' + that.token,
                },
            };

            that.authAxios
                .post(url, data, cfg)
                .then((logoutKeycloakResponse) => {
                    if (logoutKeycloakResponse.status === 200) {
                        const res = logoutKeycloakResponse.data;
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                })
                .catch((error) => {
                    console.error('logoutKeycloak error', error.response);
                    if (error.response) {
                        that.error = error.response.data.error;
                        that.errorDescription = error.response.data.error_description;
                    } else {
                        that.error = 'ERR';
                        that.errorDescription = 'Unknown error';
                    }

                    reject(false);
                });
        });
    }

    async auth(userName, password) {
        const that = this;
        return new Promise(async function (resolve, reject) {
            const url = config.apiUrl + '/auth';

            const data = {
                userName,
                password,
                responseType: 'JSON',
            };
            let cfg = {
                // headers: {
                //     'Content-Type': 'application/x-www-form-urlencoded',
                // },
            };

            let reqTime = new Date().getTime();

            that.authAxios
                .post(url, data, cfg)
                .then((authResponse) => {
                    if (authResponse.status === 200) {
                        const res = authResponse.data;

                        if (res.access_token) {
                            const token = res.access_token;
                            const refreshToken = res.refreshToken;

                            reqTime = (reqTime + new Date().getTime()) / 2;

                            that.setToken(token, refreshToken, res.id_token, reqTime);

                            that.storage.add({
                                state: 'token',
                                expires: that.tokenParsed?.exp ? that.tokenParsed.exp * 1000 : new Date().getTime() + 60 * 60 * 1000,
                                token: token,
                                refreshToken: refreshToken,
                                skewTime: reqTime,
                            });

                            resolve(true);
                        } else if (res.token && res.success) {
                            const token = res.token;
                            const refreshToken = res.refreshToken;

                            reqTime = (reqTime + new Date().getTime()) / 2;

                            that.setToken(token, refreshToken, null, reqTime);

                            that.storage.add({
                                state: 'token',
                                expires: that.tokenParsed?.exp ? that.tokenParsed.exp * 1000 : new Date().getTime() + 60 * 60 * 1000,
                                token: token,
                                refreshToken: refreshToken,
                                skewTime: reqTime,
                            });

                            resolve(true);
                        } else {
                            // TODO: set not authorized
                            that.error = 'ERR';
                            that.errorDescription = 'Invalid user credentials';
                            that.locked = res?.status === 'LOCKED';
                            that.storage.remove('token');
                            that.setToken();
                            reject(false);
                        }
                    } else {
                        // TODO: set not authorized
                        that.error = 'ERR';
                        that.errorDescription = 'Invalid user credentials';
                        that.storage.remove('token');
                        that.setToken();
                        reject(false);
                    }
                })
                .catch((error) => {
                    console.error('auth error', error.response);
                    if (error.response) {
                        that.error = error.response.data.error;
                        that.errorDescription = error.response.data.error_description;
                    } else {
                        that.error = 'ERR';
                        that.errorDescription = 'Unknown error';
                    }

                    // TODO: set not authorized
                    that.storage.remove('token');
                    that.setToken();
                    reject(error);
                });
        });
    }

    async updateToken(minValidity) {
        const that = this;

        minValidity = minValidity || 5;

        let refreshToken = false;

        if (this.refreshTokenCancelled) {
            console.info('[AUTH] Refreshing token: cancelled');
            return Promise.resolve(false);
        }

        if (minValidity == -1) {
            refreshToken = true;
            console.info('[AUTH] Refreshing token: forced refresh');
        } else if (!this.tokenParsed || this.isTokenExpired(minValidity) || this.isRefreshTokenExpired(minValidity)) {
            refreshToken = true;
            console.info('[AUTH] Refreshing token: token or refreshToken expired');
        }

        if (!refreshToken) {
            return Promise.resolve(false);
        } else {
            return new Promise(async function (resolve, reject) {
                const url = config.apiUrl + '/auth/refreshToken';

                const data = {
                    refresh_token: that.refreshToken,
                };
                const cfg = {
                    // headers: {
                    //     'Content-Type': 'application/x-www-form-urlencoded',
                    // },
                };

                let reqTime = new Date().getTime();

                that.authAxios
                    .post(url, data, cfg)
                    .then((refreshTokenResponse) => {
                        if (refreshTokenResponse.status === 200) {
                            const res = refreshTokenResponse.data;
                            if (res.access_token) {
                                reqTime = (reqTime + new Date().getTime()) / 2;

                                that.setToken(res.access_token, res.refresh_token, res.id_token, reqTime);

                                that.storage.add({
                                    state: 'token',
                                    expires: that.tokenParsed.exp ? that.tokenParsed.exp * 1000 : new Date().getTime() + 60 * 60 * 1000,
                                    token: res.access_token,
                                    refreshToken: res.refresh_token,
                                    skewTime: reqTime,
                                });

                                let iframe = document.getElementsByClassName('post-message-access');
                                if (iframe && iframe.length > 0) {
                                    let frameWindow = iframe[0] && 'contentWindow' in iframe[0] ? iframe[0].contentWindow : null;
                                    if (frameWindow) {
                                        let msgData = {
                                            type: 'refreshToken',
                                            data: {
                                                name: 'refreshToken',
                                                newToken: res.access_token,
                                                newRefreshToken: res.refresh_token,
                                            },
                                        };
                                        frameWindow.postMessage(msgData, '*');
                                    }
                                }
                                resolve(true);
                            } else {
                                // TODO: set failed refresh token
                                reject(false);
                            }
                        } else {
                            // TODO: set failed refresh token
                            reject(false);
                        }
                    })
                    .catch((error) => {
                        console.error('refreshToken error', error);
                        // TODO: set failed refresh token
                        reject(false);
                    });
            });
        }
    }

    async logoutApi() {
        const that = this;
        return new Promise(async function (resolve, reject) {
            const url = config.apiUrl + '/auth?refreshToken=' + encodeURIComponent(that.refreshToken);

            const cfg = {
                headers: {
                    // 'Content-Type': 'application/x-www-form-urlencoded',
                    // 'Authorization': 'bearer ' + that.token,
                },
            };

            that.authAxios
                .delete(url, cfg)
                .then((logoutResponse) => {
                    if (logoutResponse.status === 200) {
                        const res = logoutResponse.data;
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                })
                .catch((error) => {
                    console.error('logout error', error.response);
                    if (error.response) {
                        that.error = error.response.data.error;
                        that.errorDescription = error.response.data.error_description;
                    } else {
                        that.error = 'ERR';
                        that.errorDescription = 'Unknown error';
                    }

                    reject(false);
                });
        });
    }

    async loadUserInfo() {
        const that = this;
        return new Promise(async function (resolve, reject) {
            const url = config.auth.url + '/realms/' + config.auth.realm + '/protocol/openid-connect/userinfo';

            const cfg = {
                headers: {
                    // 'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json',
                    Authorization: 'bearer ' + that.token,
                },
            };

            that.authAxios
                .get(url, cfg)
                .then((userResponse) => {
                    if (userResponse.status === 200) {
                        const userInfo = userResponse.data;

                        resolve(userInfo);
                    } else {
                        reject(null);
                    }
                })
                .catch((error) => {
                    console.error('userInfo error', error);
                    reject(null);
                });
        });
    }

    isTokenExpired(minValidity) {
        if (!this.tokenParsed || !this.refreshToken) {
            throw 'Not authenticated';
        }

        if (this.timeSkew == null) {
            console.info('[AUTH] Unable to determine if token is expired as timeskew is not set');
            return true;
        }

        var expiresIn = this.tokenParsed.exp - Math.ceil(new Date().getTime() / 1000) + this.timeSkew;
        if (minValidity) {
            if (isNaN(minValidity)) {
                throw 'Invalid minValidity';
            }
            expiresIn -= minValidity;
        }
        return expiresIn < 0;
    }

    isRefreshTokenExpired(minValidity) {
        if (!this.tokenParsed || !this.refreshToken) {
            throw 'Not authenticated';
        }

        if (this.timeSkew == null) {
            console.info('[AUTH] Unable to determine if token is expired as timeskew is not set');
            return true;
        }

        var expiresIn = this.refreshTokenParsed.exp - Math.ceil(new Date().getTime() / 1000) + this.timeSkew;
        if (minValidity) {
            if (isNaN(minValidity)) {
                throw 'Invalid minValidity';
            }
            expiresIn -= minValidity;
        }
        return expiresIn < 0;
    }

    storeToken() {
        if (this.token) {
            this.storage.add({
                state: 'token',
                expires: this.tokenParsed.exp ? this.tokenParsed.exp * 1000 : new Date().getTime() + 60 * 60 * 1000,
                token: this.token,
                refreshToken: this.refreshToken,
            });
        } else {
            this.storage.remove('token');
        }
    }

    loadTokenFromStorage() {
        const storageToken = this.storage.get('token');
        if (storageToken) {
            this.setToken(
                storageToken.token,
                storageToken.refreshToken,
                storageToken.idToken,
                storageToken.skewTime,
                config?.debugNoTokenAuth,
            );
        } else {
            this.setToken();
        }

        return this.authenticated;
    }

    clearToken() {
        this.setToken();
        // TODO: reload ?
        // TODO: redirect to main page
        window.location.reload();
    }

    logout(redirectPath) {
        const exec = () => {
            this.setToken();
            this.storage.remove('token');
            sessionStorage.removeItem('maintenance');
            if (redirectPath) {
                window.location.href = redirectPath;
            } else {
                window.location.reload();
            }
        };
        this.logoutApi()
            .then((value) => {
                exec();
            })
            .catch((reason) => {
                exec();
            });
    }

    setTokenFromParams(token) {
        this.storage.add({
            state: 'token',
            expires: new Date().getTime() + 60 * 60 * 1000,
            token: token,
            refreshToken: null,
            skewTime: null,
        });

        this.refreshTokenCancelled = true;
    }

    setToken(token, refreshToken, idToken, timeLocal) {
        if (this.tokenTimeoutHandle) {
            clearTimeout(this.tokenTimeoutHandle);
            this.tokenTimeoutHandle = null;
        }

        if (refreshToken) {
            this.refreshToken = refreshToken;
            this.refreshTokenParsed = this.parseToken(refreshToken);
        } else {
            this.refreshToken = null;
            this.refreshTokenParsed = null;
        }

        if (idToken) {
            this.idToken = idToken;
            this.idTokenParsed = this.parseToken(idToken);
        } else {
            this.idToken = null;
            this.idTokenParsed = null;
        }

        if (token) {
            this.token = token;
            this.tokenParsed = this.parseToken(token);
            this.sessionId = this.tokenParsed?.session_state;
            this.authenticated = true;
            this.subject = this.tokenParsed?.sub;
            this.realmAccess = this.tokenParsed?.realm_access;
            this.resourceAccess = this.tokenParsed?.resource_access;

            // console.log("[AUTH] setToken", this);

            if (timeLocal) {
                this.timeSkew = Math.floor(timeLocal / 1000) - this.tokenParsed?.iat;
            }

            if (this.timeSkew != null) {
                // console.info('[AUTH] Estimated time difference between browser and server is ' + this.timeSkew + ' seconds');

                if (this.onTokenExpired) {
                    var expiresIn = (this.tokenParsed?.['exp'] - new Date().getTime() / 1000 + this.timeSkew) * 1000;
                    console.info('[AUTH] Token expires in ' + Math.round(expiresIn / 1000) + ' s');
                    if (expiresIn <= 0) {
                        this.onTokenExpired();
                    } else {
                        this.tokenTimeoutHandle = setTimeout(this.onTokenExpired, expiresIn);
                    }
                }
            }
        } else {
            this.token = null;
            this.tokenParsed = null;
            this.subject = null;
            this.realmAccess = null;
            this.resourceAccess = null;

            this.authenticated = false;
        }
    }

    parseToken(str) {
        str = str.split('.')[1];

        str = str.replace('/-/g', '+');
        str = str.replace('/_/g', '/');
        switch (str.length % 4) {
            case 0:
                break;
            case 2:
                str += '==';
                break;
            case 3:
                str += '=';
                break;
            default:
                throw 'Invalid token';
        }

        str = (str + '===').slice(0, str.length + (str.length % 4));
        str = str.replace(/-/g, '+').replace(/_/g, '/');

        str = decodeURIComponent(escape(atob(str)));

        str = JSON.parse(str);
        return str;
    }
}

export { LocalStorage, Auth };
